import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { updateDates, search } from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';

const mapState = ({ queryParams }: StateType) => {
  const { dates } = queryParams;

  return {
    selectedValue: dates.exact,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onDatesUpdate(dates: { exact?: string }) {
    dispatch(updateDates(dates));
    dispatch(search({ reason: 'faceted' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
